import React,{useState,useEffect} from 'react'

function Googleads({props}) {
  return (<></>)
}

export default Googleads